import { Tag } from 'antd';
import { useTranslation } from 'translations/hooks';

import { RingValidationDetailV1OutputDto } from 'generated/apiSchemas';

type RingComplianceStatus = RingValidationDetailV1OutputDto['status'];

const STATUS_STYLES: Record<
  RingComplianceStatus,
  { color: string; background: string; border: string }
> = {
  WAITING_COMPLIANCE: {
    color: '#614700',
    background: '#FFFBE6',
    border: '#FFE58F',
  },
  COMPLIANT: { color: '#018FAB', background: '#DDFFFC', border: '#C9EBFA' },
  APPROVED: { color: '#01AB61', background: '#DDFFE4', border: '#C9FAD8' },
  REFUSED: { color: '#AB2001', background: '#FFE6DD', border: '#FFE2DD' },
};

export const RingComplianceStatusTag = ({
  status,
}: {
  status: RingComplianceStatus;
}) => {
  const { t } = useTranslation();
  const styles = STATUS_STYLES[status];

  return (
    <Tag
      style={{
        color: styles.color,
        backgroundColor: styles.background,
        borderColor: styles.border,
        borderRadius: 10,
      }}
    >
      <span style={{ marginRight: 4 }}>&#x25CF;</span>
      {t('qualityControl.ringComplianceReport.detail.status.state', {
        context: status,
      })}
    </Tag>
  );
};
